/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let briefCaseApiURL = root.briefCaseApiUrl.link;
let sharedBriefcaseApiURL = root.sharedBriefcaseApiUrl.link;
let sharedBriefcaseForUserSpcApiUrl = root.sharedBriefcaseForUserSpcApiUrl.link;
let sharedBriefcaseRemovedApiUrl = root.sharedBriefcaseRemovedApiUrl.link;
let briefcaseStorageInfoOfTeamHeadApiUrl = root.briefcaseStorageInfoOfTeamHeadApiUrl.link;
let storageBreakDownOfTeamHeadApiUrl = root.storageBreakDownOfTeamHeadApiUrl.link;
let briefcaseActivityLogApiUrl = root.briefcaseActivityLogApiUrl.link;

export default {
  state: {
   getBriefcaseListState:{},
   getSharedBriefcaseListState:{},
   getShareBriefcaseListUserSpecificState:{},
   getbriefcaseStorageInfoState:{},
   breakdownStorageState:{},
   briefcaseActivityLogState:{}
  },
  mutations: {
    getBriefcaseListMutation(state, value) {
      Vue.set(state, 'getBriefcaseListState', value);
    },
    getSharedBriefcaseListMutation(state, value) {
      Vue.set(state, 'getSharedBriefcaseListState', value);
    },
    getShareBriefcaseListUserSpecificStateMutation(state, value) {
      Vue.set(state, 'getShareBriefcaseListUserSpecificState', value);
    },
    getbriefcaseStorageInfoMutation(state, value) {
      Vue.set(state, 'getbriefcaseStorageInfoState', value);
    },
    breakdownStorageMutation(state, value) {
      Vue.set(state, 'breakdownStorageState', value);
    },
    briefcaseActivityLogMutation(state, value) {
      Vue.set(state, 'briefcaseActivityLogState', value);
    }
  },
  actions: {
    // Briefcase Activity Log action
    getbriefcaseActivityLogAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(briefcaseActivityLogApiUrl).then(res => {
              context.commit('briefcaseActivityLogMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Briefcase Storage Info action
    getbriefcaseStorageBreakdownAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(storageBreakDownOfTeamHeadApiUrl).then(res => {
              context.commit('breakdownStorageMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Briefcase get list action
    getbriefcaseStorageInfoAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(briefcaseStorageInfoOfTeamHeadApiUrl).then(res => {
              context.commit('getbriefcaseStorageInfoMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Removed Shared Briefcase action
    removeShareBriefcaseDetailsByIDAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(sharedBriefcaseRemovedApiUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Shared Briefcase List For User Specific action
    getShareBriefcaseListUserSpecificAction(context) {
        return new Promise((resolve, reject) => {
            axios.get(sharedBriefcaseForUserSpcApiUrl).then(res => {
              context.commit('getShareBriefcaseListUserSpecificStateMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Shared Briefcase Details With User action
    shareBriefcaseDetailsWithUserAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(sharedBriefcaseApiURL,payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Shared Briefcase get list action
    getSharedBriefcaselistAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(sharedBriefcaseApiURL + '?shared_user=' + payload.id).then(res => {
              context.commit('getSharedBriefcaseListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Shared Briefcase get list action
    getSharedBriefcaseDetailsByIDAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(sharedBriefcaseApiURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Briefcase get list action
    getbriefcaselistAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(briefCaseApiURL).then(res => {
              context.commit('getBriefcaseListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Briefcase Details
    createBriefcaseDetailsAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(briefCaseApiURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Briefcase Details
    updateBriefcaseDetailsAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(briefCaseApiURL + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Briefcase Details By Id
    getBriefcaseDetailsByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(briefCaseApiURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Delete Briefcase Details By Id
    removeBriefcaseDetailsByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(briefCaseApiURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getBriefcaseListGetters: state => state.getBriefcaseListState,
    getSharedBriefcaseListGetters: state => state.getSharedBriefcaseListState,
    getShareBriefcaseListUserSpecificGetters: state => state.getShareBriefcaseListUserSpecificState,
    getbriefcaseStorageInfoGetters: state => state.getbriefcaseStorageInfoState,
    breakdownStorageGetters: state => state.breakdownStorageState,
    briefcaseActivityLogGetters: state => state.briefcaseActivityLogState,
  }
}